import successHandler from "Utility/successHandler/successHandler";

const tokenInterceptor = (response) => {
    return successHandler(response);
}

export default tokenInterceptor;